// The backend is inconsistent with naming, and turning back and forth between casing in the function itself
//  makes the function more complex, so for now we are just adding the values we see here
const prioritizedHeader: string[] = [];

export function sortTableHeaders(headers: string[]): string[] {
  const result: string[] = [];

  // Add prioritized keys to the result if they exist in allKeys
  prioritizedHeader.forEach((prioritizedHeader) => {
    if (
      headers.includes(prioritizedHeader) &&
      !result.includes(prioritizedHeader)
    ) {
      result.push(prioritizedHeader);
    }
  });

  // Add the remaining keys from allKeys ensuring no duplicates
  headers.forEach((key) => {
    if (!result.includes(key)) {
      result.push(key);
    }
  });

  return result;
}
